// should this ent replace another ent,
// or should this ent only seek to fill missing spots?

export const enum Clobber {
  No = 1,
  Yes = 2,
}
